// @ts-check

(function () {
  const popup = /** @type {HTMLElement | null} */ (document.getElementById('added-to-cart-popup'));
  const dialog = /** @type {HTMLDialogElement | null} */ (
    document.getElementById('atc-popup-dialog')
  );
  if (!popup || !dialog) return;

  const productId = popup.dataset.productId;
  const currencySymbol = popup.dataset.currencySymbol || '£';
  const comparePriceMap = /** @type {Record<string, number>} */ ({});
  try {
    const parsed = JSON.parse(popup.dataset.comparePrices || '{}');
    Object.assign(comparePriceMap, parsed);
  } catch {
    // ignore parse errors
  }

  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer && cartDrawer.hasAttribute('auto-open')) {
    cartDrawer.removeAttribute('auto-open');
  }

  function closePopup() {
    if (dialog) dialog.close();
  }

  const closeBtn = document.getElementById('atc-popup-close');
  const continueBtn = document.getElementById('atc-popup-continue');
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (continueBtn) continueBtn.addEventListener('click', closePopup);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closePopup();
  });

  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closePopup();
    }
  });

  document.addEventListener('cart:update', function (event) {
    const detail = /** @type {any} */ (event).detail || {};
    const data = detail.data || {};
    data.sourceId = detail.sourceId || null;

    if (data.source !== 'product-form-component' && data.source !== 'addon-drawer') return;
    if (data.didError) return;

    if (cartDrawer) {
      const drawerDialog = /** @type {HTMLDialogElement | null} */ (
        cartDrawer.querySelector('dialog')
      );
      if (drawerDialog && drawerDialog.open) {
        drawerDialog.close();
      }
    }

    if (dialog && dialog.open) dialog.close();

    const addedItems = detail.resource && detail.resource.items ? detail.resource.items : null;

    if (addedItems && data.source === 'addon-drawer') {
      renderPopupFromAddedItems(addedItems, data);
      if (dialog) dialog.showModal();
    } else {
      fetch('/cart.js?t=' + Date.now())
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          renderPopup(cart, data);
          if (dialog) dialog.showModal();
        })
        .catch(function (err) {
          console.error('Added to cart popup error:', err);
        });
    }
  });

  /**
   * @param {any} cart
   * @param {any} eventData
   */
  function renderPopup(cart, eventData) {
    const pid = eventData.productId || productId;

    let addedVariantId = /** @type {string | null} */ (null);
    if (eventData.variantId) {
      addedVariantId = String(eventData.variantId);
    } else if (eventData.sourceId && eventData.sourceId !== 'addon-drawer') {
      addedVariantId = String(eventData.sourceId);
    }
    if (!addedVariantId) {
      const formInput = /** @type {HTMLInputElement | null} */ (
        document.querySelector('product-form-component input[name="id"]')
      );
      if (formInput) addedVariantId = String(formInput.value);
    }

    const mainItems = cart.items.filter(function (/** @type {any} */ item) {
      return (
        String(item.product_id) === String(pid) && !(item.properties && item.properties._upsell_for)
      );
    });

    let mainItem = /** @type {any} */ (null);
    if (addedVariantId) {
      for (let i = mainItems.length - 1; i >= 0; i--) {
        if (String(mainItems[i].variant_id) === addedVariantId) {
          mainItem = mainItems[i];
          break;
        }
      }
    }
    if (!mainItem) mainItem = mainItems[mainItems.length - 1];
    if (!mainItem) return;

    renderMainProduct(mainItem);

    const groupId = mainItem.properties ? mainItem.properties._product_group_id : null;
    const mainVariantId = String(mainItem.variant_id);

    let upsellItems = [];
    if (groupId) {
      upsellItems = cart.items.filter(function (/** @type {any} */ item) {
        const upsellFor =
          item.properties && item.properties._upsell_for
            ? String(item.properties._upsell_for).trim()
            : '';
        const itemGroupId =
          item.properties && item.properties._product_group_id
            ? String(item.properties._product_group_id).trim()
            : '';
        return (
          upsellFor !== '' &&
          upsellFor !== 'null' &&
          upsellFor === mainVariantId &&
          itemGroupId === String(groupId).trim()
        );
      });
    }

    renderUpsellItems(upsellItems);
  }

  /**
   * @param {any[]} addedItems
   * @param {any} eventData
   */
  function renderPopupFromAddedItems(addedItems, eventData) {
    const mainVariantId = eventData.variantId ? String(eventData.variantId) : null;

    let mainItem = /** @type {any} */ (null);
    for (let i = 0; i < addedItems.length; i++) {
      const item = addedItems[i];
      if (!(item.properties && item.properties._upsell_for)) {
        if (!mainVariantId || String(item.variant_id) === mainVariantId) {
          mainItem = item;
          break;
        }
      }
    }
    if (!mainItem) mainItem = addedItems[0];
    if (!mainItem) return;

    renderMainProduct(mainItem);

    const groupId = mainItem.properties ? mainItem.properties._product_group_id : null;
    const mVid = String(mainItem.variant_id);
    let upsellItems = [];
    if (groupId) {
      upsellItems = addedItems.filter(function (/** @type {any} */ item) {
        const upsellFor =
          item.properties && item.properties._upsell_for
            ? String(item.properties._upsell_for).trim()
            : '';
        const itemGroupId =
          item.properties && item.properties._product_group_id
            ? String(item.properties._product_group_id).trim()
            : '';
        return (
          upsellFor !== '' &&
          upsellFor !== 'null' &&
          upsellFor === mVid &&
          itemGroupId === String(groupId).trim()
        );
      });
    }
    renderUpsellItems(upsellItems);
  }

  /** @param {any} item */
  function renderMainProduct(item) {
    if (!popup) return;
    const container = /** @type {HTMLElement | null} */ (
      popup.querySelector('[data-main-product]')
    );
    if (!container) return;

    const image = /** @type {HTMLImageElement | null} */ (
      container.querySelector('[data-product-image]')
    );
    const title = container.querySelector('[data-product-title]');
    const variants = container.querySelector('[data-product-variants]');
    const price = container.querySelector('[data-product-price]');
    const comparePrice = /** @type {HTMLElement | null} */ (
      container.querySelector('[data-product-compare-price]')
    );
    const propertiesEl = container.querySelector('[data-product-properties]');

    if (image && item.image) {
      image.src = getSizedImageUrl(item.image, '160x');
      image.alt = item.product_title;
      image.style.display = '';
    } else if (image) {
      image.style.display = 'none';
    }

    if (title) title.textContent = item.product_title;

    if (variants) {
      variants.innerHTML = '';
    }

    if (price) price.textContent = formatMoney(item.final_line_price);

    if (propertiesEl) {
      let propHtml = '';

      const options = item.options_with_values || [];
      options.forEach(function (/** @type {any} */ opt) {
        if (!opt.value || opt.value === 'Default Title') return;
        propHtml +=
          '<div class="atc-popup__property">' +
          '<dt>' +
          opt.name +
          ':</dt>' +
          '<dd>' +
          opt.value +
          '</dd>' +
          '</div>';
      });

      const props = item.properties || {};
      Object.keys(props).forEach(function (key) {
        if (key.charAt(0) === '_' || props[key] === '' || props[key] === null) return;
        propHtml +=
          '<div class="atc-popup__property">' +
          '<dt>' +
          key +
          ':</dt>' +
          '<dd>' +
          props[key] +
          '</dd>' +
          '</div>';
      });

      propertiesEl.innerHTML = propHtml;
    }

    if (comparePrice) {
      const variantCompareAt = comparePriceMap[String(item.variant_id)] || 0;
      const compareAtPrice = variantCompareAt || item.compare_at_price || 0;
      if (compareAtPrice && compareAtPrice > item.final_price) {
        comparePrice.textContent = formatMoney(compareAtPrice);
        comparePrice.style.display = '';
      } else {
        comparePrice.style.display = 'none';
      }
    }
  }

  /** @param {any[]} items */
  function renderUpsellItems(items) {
    if (!popup) return;
    const section = /** @type {HTMLElement | null} */ (
      popup.querySelector('[data-upsell-section]')
    );
    const list = popup.querySelector('[data-upsell-list]');
    if (!section || !list) return;

    if (items.length === 0) {
      section.style.display = 'none';
      return;
    }

    section.style.display = '';
    list.innerHTML = items
      .map(function (/** @type {any} */ item) {
        return (
          '<li class="atc-popup__upsell-item">' +
          '<div class="atc-popup__upsell-image-wrap">' +
          (item.image
            ? '<img src="' +
              getSizedImageUrl(item.image, '80x') +
              '" alt="' +
              item.product_title +
              '" class="atc-popup__upsell-image" loading="lazy">'
            : '') +
          '</div>' +
          '<div class="atc-popup__upsell-info">' +
          '<span class="atc-popup__upsell-title">' +
          item.product_title +
          '</span>' +
          (item.variant_title
            ? '<span class="atc-popup__upsell-variant">' + item.variant_title + '</span>'
            : '') +
          '<div class="atc-popup__upsell-price-row">' +
          '<span class="atc-popup__upsell-price">' +
          formatMoney(item.final_price) +
          '</span>' +
          (function () {
            const upsellCompareAt =
              comparePriceMap[String(item.variant_id)] || item.compare_at_price || 0;
            return upsellCompareAt && upsellCompareAt > item.final_price
              ? '<span class="atc-popup__upsell-compare-price">' +
                  formatMoney(upsellCompareAt) +
                  '</span>'
              : '';
          })() +
          '</div>' +
          '</div></li>'
        );
      })
      .join('');
  }

  /** @param {number} amount */
  function formatMoney(amount) {
    return currencySymbol + (amount / 100).toFixed(2);
  }

  /**
   * @param {string} url
   * @param {string} size
   */
  function getSizedImageUrl(url, size) {
    if (!url) return '';
    const match = url.match(/^(.+)\.(\w+)(\?.*)?$/);
    if (match) return match[1] + '_' + size + '.' + match[2] + (match[3] || '');
    return url;
  }
})();
